var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2822 20.25H0.75V16.9465L13.5159 4.7609L17.0124 8.09846L4.2822 20.25ZM21.1247 3.61334C21.2918 3.77282 21.2918 4.0136 21.1247 4.17308L19.4062 5.81346L15.9097 2.47591L17.5777 0.883719C17.7645 0.705427 18.0783 0.705427 18.2651 0.883719L21.1247 3.61334Z",
    fill: "#0C6CDE",
    stroke: "#0C6CDE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/Edit_Blue.d3f1d52c4b6884bb68472695250a592a.svg";
export { ForwardRef as ReactComponent };